export default {
    messages (state) {
      return state.messages
    },

    selectedMessage (state) {
        return state.selectedMessage
    },

    getMessage: state => (messageId) => {
      return state.messages().find(message => message.greetingId === messageId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/messages/getters.js